// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetLashPatientDebitCardLast4RequestModel {
    static getAttributeTypeMap() {
        return GetLashPatientDebitCardLast4RequestModel.attributeTypeMap;
    }
}
GetLashPatientDebitCardLast4RequestModel.discriminator = undefined;
GetLashPatientDebitCardLast4RequestModel.additionalProperties = false;
GetLashPatientDebitCardLast4RequestModel.attributeTypeMap = [
    {
        "name": "patientLashId",
        "baseName": "patientLashId",
        "type": "string"
    },
];
//# sourceMappingURL=getLashPatientDebitCardLast4RequestModel.js.map